import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Onboarding } from "../onboarding/Onboarding";
import { useRenderCommonRoutes } from "./useRenderCommonRoutes";

export const OnboardingRoutes: React.FC = () => {
    const commonRoutes = useRenderCommonRoutes();

    return (
        <Routes>
            <Route path="/onboarding" element={<Onboarding />} />
            {commonRoutes}

            <Route path="*" element={<Navigate to="/onboarding" replace />} />
        </Routes>
    );
};
